import React, { useState, useEffect } from "react";
import {createUser} from '../../../lib/auth'
import {addData,updateData } from "../../../lib/profiles"
import { getIdData } from '../../../lib/studentinfo'
import { getIdData as getProfile , updateData as updateProfile} from "../../../lib/profiles"
import StudentTopMenu from '../studentGrid/studenttopmenu'
import StudentInfoBox from '../studentGrid/studentinfobox'

import { useNavigate, useParams } from 'react-router-dom'

export default function AdminParent() {
  const [studentInfo, setStudentInfo] = useState()
  const [parentInfo, setParentInfo] = useState()
  const [showmessage, setShowMessage] = useState(false);
  const [validationError, setValidationError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [recId, setRecId] = useState(0)
  let { slug } = useParams()

  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [name, setName] = useState();
  const [surName, setsurName] = useState();

  const [data, setData] = useState();
  const navigate = useNavigate();


  console.log("email",email);

  async function GetData() {
    setShowMessage(false);

    const info = await getIdData(slug)
    setStudentInfo(info)
    console.log('info', info)

    if(info[0].parentId)
  {
    console.log("var",info[0].parentId);
    const userprofile = await getProfile(info[0].parentId);
    setParentInfo(userprofile[0]);
    setRecId(userprofile[0].id);
    setEmail(userprofile[0].email);
    setName(userprofile[0].name);
    setsurName(userprofile[0].surname);
}
  else
  {
    console.log("yok",info[0].parentId);
  }
}
  const handleSubmit = async (e) => {
      e.preventDefault();

      if(recId == 0)
      {
        const { data, error } = await createUser(email,password,'Parent');
        console.log("Parent data",data);
        
        if(data.user)
          {
      await addData({
        id: data.user.id,
        email: email,
        role: 'Parent',
        name: name,
        surname: surName,
        studentId: slug,
      });

      await updateData({
        id: slug,
        parentId : data.user.id,
        });
      console.log("data",data.user.id);
    }
      //navigate(`/admin/admin-studentstep2/${data.user.id}/Add`);

      if(error)
        {
           setValidationError(true);
           setErrorMessage("Error : " + error.message);
           
        }
    }
    else
    {
      await updateProfile({
        id: recId,
        name: name,
        surname: surName
        });
    }
    setShowMessage(true);

/*
burada bazı  bilgileri ekleyebiliriz.

    const { data, error } = await supabase.auth.updateUser({
      data: { hello: 'world' }
    })
*/
    /*
    handle_new_user
begin
  insert into public.profiles (id, full_name, avatar_url,email)
  values (new.id, new.raw_user_meta_data->>'full_name', new.raw_user_meta_data->>'avatar_url',new.email);
  return new;
end
    */ 
  };

  useEffect(() => {
    GetData()
  }, [])

  return (
    <div className='col-12'>
    <div className='tak-instruct-group'>
      <div className='row'>
        <div className='col-md-12'>
          <StudentInfoBox slug={slug} />
          <StudentTopMenu slug={slug} activeMenu={'Parent'} />
          <div className='settings-widget'>
            <div className='settings-inner-blk p-0'>
              <div className='checkout-form personal-address add-course-info'>
                <div className='personal-info-head'>
                  <h4>Parent Details</h4>
                </div>
                {validationError && (
                            <div className="alert alert-danger">
                              {errorMessage}
                            </div>
                          )}
                {showmessage && (
                              <div className="alert alert-success alert-dismissible fade show" role="alert">
                              <strong>Updated!</strong> your Settings.
                              <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                            </div>
            )}
                <div className="col-xl-9 col-md-8">
                  <div className="checkout-form personal-address add-course-info ">
                    <form role="form" onSubmit={handleSubmit}>
                      <div className="row mx-auto">
                      <div className="col-6">
                        <div className="form-group">
                            <label className="form-control-label">
                              Name
                            </label>
                            <input
                              type="text"
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                              className="form-control"
                              placeholder="Enter Name"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-6">
                        <div className="form-group">
                            <label className="form-control-label">
                              Surname
                            </label>
                            <input
                              type="text"
                              value={surName}
                              onChange={(e) => setsurName(e.target.value)}
                              className="form-control"
                              placeholder="Enter Surname"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-6">
                        <div className="form-group">
                            <label className="form-control-label">
                              Mail
                            </label>
                            <input
                              type="email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              className="form-control"
                              placeholder="Enter Email"
                              required
                              disabled={recId !== 0}
                            />
                          </div>
                        </div>
                        <div className="col-6">
                        <div className="form-group">
                            <label className="form-control-label">
                              Password
                            </label>
                            <input
                              type="password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              className="form-control"
                              placeholder="Enter Pass"
                              required
                              disabled={recId !== 0}
                            />
                          </div>
                        </div>
                        <div className="update-profile d-flex justify-content-between">
                          <button type="submit"  className="btn btn-primary">
                            Update  
                          </button>
                          <button onClick={() => navigate(-1)} className="btn btn-black btn-sm">
                          Cancel
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
            </div>
      </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
}